export default "__VITE_ASSET__C6EvWN2m__"